import store from '@/store'
import auth from '@/auth/helpers'

export default class Service {
  constructor (options) {
    this.id = store.state.auth.user.id
  }

  tagsAutoSuggestions (tag) {
    return auth.get('/tags', {tag: tag})
      .then((response) => {
        return new Promise((resolve) => { resolve(response) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }

  uploadImage (image) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return auth.post('/upload/image', image, config)
      .then((response) => {
        return new Promise((resolve) => { resolve(response) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }

  uploadVideo (video, config) {
    return auth.post('/upload/video', video, config)
      .then((response) => {
        return new Promise((resolve) => { resolve(response) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }

  fetchAdOptions () {
    return auth.get('/ad/defaultOptions')
      .then((response) => {
        return new Promise((resolve) => { resolve(response) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/status-update/service.js